/** Convert a Blob/File into a `data:` URL so previews work under CSP `img-src data:`. */
export async function blobToDataUrl(blob: Blob): Promise<string> {
  try {
    if (typeof FileReader === "function") {
      const fromReader = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(typeof reader.result === "string" ? reader.result : "");
        reader.onerror = () => reject(reader.error ?? new Error("Could not read image."));
        reader.readAsDataURL(blob);
      });
      if (fromReader) return fromReader;
    }
  } catch {
    /* Fall through to arrayBuffer so jsdom/test File objects still preview. */
  }
  try {
    const bytes = new Uint8Array(await blob.arrayBuffer());
    const chunk = 0x8000;
    let binary = "";
    for (let index = 0; index < bytes.length; index += chunk) {
      binary += String.fromCharCode(...bytes.subarray(index, index + chunk));
    }
    return `data:${blob.type || "application/octet-stream"};base64,${btoa(binary)}`;
  } catch {
    return "";
  }
}
